<div class="form">
  <form [formGroup]="editForm">
    <p class="heading" i18n>Edit Analysis</p>
    <div class="form__fields__container">
      <app-input
        [formCntlName]="editForm.get('Name')"
        [inputType]="'text'"
        [label]="'Analysis Name'"
        [placeholder]="'Enter analysis name'"
      ></app-input>
      <mat-error *ngIf="editForm.get('Name')?.hasError('required') && editForm.get('Name')?.touched">
        Analysis name is required.
      </mat-error>
      <mat-error *ngIf="editForm.get('Name')?.hasError('whitespace') && editForm.get('Name')?.touched">
        Input cannot be just spaces.
      </mat-error>
      <mat-error *ngIf="editForm.get('Name')?.hasError('maxlength')">
        Name cannot be longer than 256 characters.
      </mat-error>

      <div class="edit-textarea">
        <label class="input-label" i18n>Description</label>
        <textarea formControlName="Description" placeholder="Enter analysis description" rows="3" i18n></textarea>
        <mat-error *ngIf="editForm.get('Description')?.hasError('maxlength') && editForm.get('Description')?.touched">
          Description cannot be longer than 1024 characters.
        </mat-error>
        <mat-error *ngIf="editForm.get('Description')?.hasError('whitespace') && editForm.get('Description')?.touched">
          Input cannot be just spaces.
        </mat-error>
      </div>
      <app-searchable-multi-select
        [label]="'Project/Group(s)'"
        [placeholder]="groupOptions.length > 0 ? 'Select Groups' : 'No groups to remove'"
        [options]="groupOptions"
        [formControlName]="'groups'"
        [multiple]="true"
        [disabledOptions]="disabledGroupOptions"
      ></app-searchable-multi-select>
    </div>
    <div class="form__btn__container">
      <app-buttons
        [isDisabled]="false"
        [name]="buttonCancel"
        [arialLabel]="arialLabel"
        [buttonType]="btnMat"
        [buttonStyle]="btnStyleText"
        (buttonClickEvent)="closePopup()"
      ></app-buttons>
      <app-buttons
        [isDisabled]="!editForm.valid || (!editForm.dirty && editForm.get('groups')?.pristine) || isSubmitting"
        [name]="buttonSave"
        [buttonType]="btnMatFlat"
        [buttonStyle]="
          !editForm.valid || (!editForm.dirty && editForm.get('groups')?.pristine) || isSubmitting
            ? btnStyleFilledSmallDisabled
            : btnStyleFilledSmall
        "
        (buttonClickEvent)="onEditSubmit()"
      ></app-buttons>
    </div>
  </form>
</div>
